

import React, { useState } from "react";
import { Label, StyledInput } from "../StyledComponents/StyledComponent";
import { useAllEmployeeDetails } from "../../hooks/useCandidate";
import { useGetSingleEmployee } from "../../hooks/useEmployees";
import { usePaySlipEmployee } from "../../hooks/usePayslip";
import Monthlyctc from "./Monthlyctc";
import payslipimg from "../../assets/images/iconns (1).png";
import CloseIcon from '@mui/icons-material/Close';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Divider,
  Box,
  Paper,
  IconButton,
  TextField,
  Chip,
  Button,
} from "@mui/material";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { blue } from "../StyledComponents/StyledComponent";
import dayjs from "dayjs";
import pdf from '../../assets/pdf.png'
import { getMediaUrl } from "../../utils/urlHelper";

// ---- FORTHEYE soft-card tokens (shared with the rest of the portal) ----
const CARD_SX = {
  p: { xs: 2, sm: 2.5, md: 3 },
  borderRadius: '22px',
  bgcolor: '#fff',
  border: '1px solid #eef0f4',
  boxShadow: '0 6px 24px rgba(17,24,39,0.05)',
};
const ACCENT = '#2f6bff';

const Payslip = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const { data: emp = [] } = useAllEmployeeDetails();
  const [selectedEmp, setSelectedEmp] = useState(null); // Store single employee
  const [openmodel, setOpenmodel] = React.useState(false);
  const { data } = useGetSingleEmployee({ id: selectedEmp?.employee_no });
  const { data: payslipdata } = usePaySlipEmployee(selectedEmp?.employee_no);
  // console.log(payslipdata);
  // console.log(payslipdata?.['payslips']);
  const payslipdataemp = payslipdata?.['payslips']
  const [selectedDates] = useState(null);
  const [pdfFileurl, setPdfFileurl] = useState(null);






  const handlemodelclose = () => setOpenmodel(!openmodel);
  const monthCTC = data?.ctc_items?.[0]?.monthly_ctc



  // console.log(pdfFileurl);

  const handleClear = () => {
    // console.log("Clicked")
    setSearchQuery('')
  };
  const filteredEmployees = searchQuery
    ? emp.filter((employee) =>
      employee.name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : '';

  const handleSelect = (employee) => {
    setSelectedEmp(employee);
    setSearchQuery("");

  };
  const clear = () => {
    setSelectedEmp(null);
  };

  const handleDate = (date) => {
    const dates = dayjs(date);
    const month = dates.format("MMMM");
    const year = dates.format("YYYY");
    const pdfFile = getPayslipPdf(month, year);
    // console.log(pdfFile);
    if (pdfFile) {
      setPdfFileurl(pdfFile);
    }
  };

  const getPayslipPdf = (month, year) => {
    const payslip = payslipdataemp.find(
      (empp) => empp.month === month && empp.year === parseInt(year)
    );
    // console.log(payslip);
    // pdf_url is the signed/absolute link the API exposes; the raw pdf_file
    // storage path is deliberately not sent to the browser.
    return payslip ? payslip.pdf_url : null;
  };



  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      {/* Header card */}
      <Paper elevation={0} sx={{ ...CARD_SX, mb: { xs: 2, md: 3 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ width: 52, height: 52, borderRadius: '16px', bgcolor: `${ACCENT}14`, color: ACCENT, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <ReceiptLongIcon />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 800, fontSize: { xs: '1.35rem', md: '1.7rem' }, color: '#111827', letterSpacing: '-0.02em', lineHeight: 1.15 }}>
              Payslip Preview
            </Typography>
            <Typography variant="body2" sx={{ color: '#6b7280' }}>
              View and download employee payslips for a selected payroll period.
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Intro / description card */}
      <Paper elevation={0} sx={{ ...CARD_SX, mb: { xs: 2, md: 3 }, color: '#4b5563', lineHeight: 1.6 }}>
        <Typography variant="body2" sx={{ color: '#4b5563', mb: 1.5 }}>
          The <strong>Payslip Preview</strong> page allows you to view and download the payslips for all
          employees for a selected payroll period. You can preview individual employee payslips and
          review detailed breakdowns such as Net pay, Gross salary, Deductions, and Loss of pay. This
          feature provides a convenient way to ensure accuracy before finalizing salary details.
        </Typography>
        <Typography variant="body2" sx={{ color: '#4b5563' }}>
          Explore the ATS HR Payslip Preview and manage payroll with ease.
        </Typography>
      </Paper>

      {/* Main content card */}
      <Paper elevation={0} sx={CARD_SX}>
        <Box sx={{ display: "flex", flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 2, md: 3 }, position: 'relative' }}>

          <Box sx={{ flexBasis: "50%", position: 'relative' }}>
            <Box
              sx={{
                width: "100%",
                height: "250px",
                overflowY: "auto",
                bgcolor: "background.paper",
                margin: "auto",
              }}
            >
              <Label>Search Employee</Label>
              <Box sx={{ display: 'flex' }}>
                <StyledInput value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                <Box onClick={handleClear}
                  sx={{
                    width: 'fit-content',
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: 700,
                    color: "#fff",
                    borderRadius: "12px",
                    background: 'linear-gradient(135deg,#3b82f6,#2f6bff)',
                    cursor: "pointer",
                    marginLeft: '7px',
                    display: 'flex',
                    alignItems: 'center',
                    transition: "transform 0.2s, box-shadow 0.2s",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      background: 'linear-gradient(135deg,#2f6bff,#2557d6)',
                    },
                    "&:active": {
                      transform: "translateY(0)",
                    },
                  }}
                >
                  Clear
                </Box>
              </Box>
              <List>
                {filteredEmployees.length > 0 ? (
                  filteredEmployees.map((employee) => (
                    <React.Fragment key={employee.id}>
                      <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                          <Avatar sx={{ bgcolor: `${ACCENT}14`, color: ACCENT, fontWeight: 700 }}>{employee.name.charAt(0)}</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={`Employee No: ${employee.employee_no}`}
                          secondary={
                            <Typography
                              onClick={() => handleSelect(employee)}
                              component="span"
                              variant="body2"
                              sx={{ color: "text.primary", display: "inline", cursor: "pointer" }}
                            >
                              {employee.name}
                            </Typography>
                          }
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </React.Fragment>
                  ))
                ) : (
                  <Typography variant="body2" sx={{ padding: 2, textAlign: "center", display: 'none' }}>
                    No employees found.
                  </Typography>
                )}
              </List>

              <div>
                {Array.isArray(payslipdataemp) && payslipdataemp.length > 0 ? (
                  <div>

                    <Label>Enter Month</Label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Select Month"
                        views={['month', 'year']}
                        value={selectedDates || null}
                        onChange={(e) => handleDate(e)}
                        renderInput={(params) => <TextField {...params} />}
                        slotProps={{
                          textField: {
                            variant: 'outlined',
                            sx: {

                              marginBottom: '20px',
                              maxHeight: '38px',
                              '& .MuiOutlinedInput-root': {
                                minWidth: '320px',
                                backgroundColor: '#f8fafc',
                                minHeight: '39px',
                                borderRadius: '12px', padding: '5px 10px', border: '1px solid #e5e7eb',
                              },
                              '& .MuiInputLabel-root': {
                                position: 'relative',
                                top: '13px',
                                width: '200px',
                                height: '40px',
                                alignItems: 'center',
                                display: 'flex',

                              },
                              '& .MuiInputBase-input.MuiOutlinedInput-input': {
                                padding: '0px',
                                height: '20px',
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: blue[300],
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: blue[500],
                              },
                              '&:hover .MuiOutlinedInput-root': {
                                borderColor: blue[500],
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: blue[700],
                              },
                              '& .MuiInputAdornment-root': {
                                position: 'absolute',
                                right: '10px',
                              },
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                    {(() => {
                      const selectedPayslip = payslipdataemp?.find(
                        (empp) => empp.month === dayjs(selectedDates).format("MMMM") && empp.year === parseInt(dayjs(selectedDates).format("YYYY"))
                      );

                      return (
                        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                          {selectedPayslip && (
                            <Chip
                              label={selectedPayslip.status || 'DRAFT'}
                              size="small"
                              sx={{
                                mb: 1,
                                fontWeight: 700,
                                border: 'none',
                                ...(selectedPayslip.status === 'PUBLISHED'
                                  ? { bgcolor: '#f0fdf4', color: '#16a34a' }
                                  : { bgcolor: '#f3f4f6', color: '#6b7280' }),
                              }}
                            />
                          )}

                          {pdfFileurl && (
                            <a href={getMediaUrl(pdfFileurl)} target="_blank" rel="noopener noreferrer">
                              <div style={{ position: 'relative', width: '50px', height: 'auto' }}>
                                <img
                                  src={pdf}
                                  alt="Download PDF"
                                  style={{ width: '50px', height: 'auto' }}
                                />
                                <span
                                  style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    color: 'white',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  Download
                                </span>
                              </div>
                            </a>
                          )}
                        </Box>
                      );
                    })()}

                  </div>

                ) : (
                  <div style={{ display: 'none' }}>No payslip data available</div>
                )}
              </div>
              <Box>
                {selectedEmp ? (
                  <Box>
                    <Box sx={{
                      display: 'flex', minWidth: '348px',
                      backgroundColor: '#fff', position: 'fixed', zIndex: '222', justifyContent: 'space-between', borderRadius: '16px', padding: '8px 14px', border: '1px solid #eef0f4', boxShadow: '0 6px 24px rgba(17,24,39,0.05)'
                    }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>  <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#111827' }}>{`${selectedEmp.employee_no}`}</Typography>
                        <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#6b7280' }}>{selectedEmp.name}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={() => setOpenmodel(true)}
                          sx={{ textTransform: 'none', borderRadius: '10px', bgcolor: ACCENT, whiteSpace: 'nowrap' }}
                        >
                          Revise Monthly CTC
                        </Button>
                        <IconButton onClick={() => clear()}><CloseIcon /></IconButton>
                      </Box>
                    </Box>


                  </Box>
                ) : (
                  <Typography style={{ display: 'none' }}>No employee selected.</Typography>
                )}
              </Box>
            </Box>
          </Box>
          <Box sx={{ flexBasis: '50%', width: '100%', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img style={{ width: '65%', height: 'auto', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }} src={payslipimg} alt="payslip" />
          </Box>
        </Box>
      </Paper>
      <Monthlyctc CTC={data?.ctc_revision} monthCTC={monthCTC} open={openmodel} handlemodelclose={handlemodelclose} selectedEmp={selectedEmp} />

    </Box>
  );
};

export default Payslip;
